import React, { Component } from "react";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";
import Step4 from "./step4";
import Step5 from "./step5";
import Step6 from "./step6";
import Navigation from "./navigation";
import axios from "axios";
import calculator_criteria from "../siteData/calculator_criteria.json";
import seguros_calculator_criteria from "../siteData/seguros/calculator_criteria.json";
import hvac_calculator_criteria from "../siteData/hvac/calculator_criteria.json";
import i18n from "../i18n";
import { generateJSONData } from "../utils/generateJSONData";


export default class multistepform extends Component {
  // constructor(props){
  //   super(props)
  hostName = window.location.hostname;
  options = this.getCalculatorCriteriaOptions(this.hostName)
  api_url = this.getLeadCloudApiURL()

  state = {
    //formType: this.getQueryVariable('type'),
    formType: "commercial",
    step: this.ifParamsMoveToStep2(),
    stateCode: this.getStateBasedOnQueryZipCode(),
    zipCode: this.getQueryVariable("zip"),
    firstName: "",
    lastName: "",
    businessName: "",
    businessMailingZipCode: this.setDefaultBusinessZipCode(),
    businessEmail: "",
    businessPhone: "",
    totalVehicles: 1,
    industry: "",
    mainVehicle: "",
    estimatedValueVehicle: "",
    usage: "",
    overnightZipCode: "",
    checkboxOvernightSameAsBusiness: false,
    ageDriver: "",
    accidentsOrTickets: "",
    liabilityLimits: "",
    bodilyInjury: "",
    propertyDamage: "",
    result: "",
    resultMonthOptm: "",
    resultMonthNormal: "",
    resultMonthPesm: "",
    resultYearOptm: "",
    resultYearNormal: "",
    resultYearPesm: "",
    availableZipCode: this.checkQueryZipCodeIsAvailable(),
    language: this.setDefaultLanguage(),
    options: this.getCalculatorCriteriaOptions(this.hostName),
    validStates: this.getValidStates(),
  };

  // field's dynamic options from json
  getCalculatorCriteriaOptions(host) {
    // console.log('ENV', process.env)
    let criteria_path = calculator_criteria;
    // console.log('HOST', host)
    switch(host){
      case host.includes("hvac"):
        criteria_path =  hvac_calculator_criteria;
      break;
      case host.includes("seguros"):
        criteria_path = seguros_calculator_criteria;
         break;
      default:
        criteria_path = calculator_criteria;
        break;
    }
    return criteria_path;
  }

  // get url's query values
  getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    // console.log(query);
    var vars = query.split("&");
    // console.log(vars);
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      // console.log(pair);
      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return "";
  }

  checkQueryZipCodeIsAvailable() {
    var zc = this.getQueryVariable("zip");
    // if zipcode has been passed through a query
    if (zc) {
      var validZipCode = false;
      const validStates = this.getValidStates();
      validStates.forEach((validState) => {
        if (
          this.options.enums[8].enum.state[validState].some((o) => o.name === zc)
        ) {
          validZipCode = true;
        }
      });
      // if the zipcode passed is outside of calculator
      // if (validZipCode === false) {
      //   return false;
      // } else {
      //   return true;
      // }
    } else {
      validZipCode = true;
    }
    // console.log("validZipCode", validZipCode);
    return validZipCode;
  }

  checkCustomZipCodeIsAvailable() {
    var zc = this.getQueryVariable("zip");
    var customZc = this.state.zipCode;
    // if zipcode has not been passed through a query, or the zipcode passed has been customized manually
    // if ((!zc && customZc) || (zc && zc !== customZc)) {
    var validZipCode = false;
    const validStates = this.getValidStates();
    // console.log( this.options );
    validStates.forEach((validState) => {
      // console.log(
      //   "zip check",
      //   this.options.enums[8].enum.state[validState].some((o) => o.name === customZc)
      // );
      if (
        this.options.enums[8].enum.state[validState].some((o) => o.name === customZc)
      ) {
        validZipCode = true;
      }
    });
    validStates.forEach((validState) => {
      // console.log(
      //   "zip check",
      //   this.options.enums[8].enum.state[validState].some((o) => o.name === zc)
      // );
      if (this.options.enums[8].enum.state[validState].some((o) => o.name === zc)) {
        validZipCode = true;
      }
    });
    // if the zip passed is outside of calculator
    // if (validZipCode === false) {
    //   return false;
    // } else {
    //   return true;
    // }
    // } else {
    // validZipCode = false;
    // }
    // console.log("checkCustomZipCodeIsAvailable", validZipCode);
    return validZipCode;
  }

  getStateBasedOnQueryZipCode() {
    var stateCode = "";
    // console.log(
    //   "this.checkQueryZipCodeIsAvailable()",
    //   this.checkQueryZipCodeIsAvailable()
    // );
    if (this.checkQueryZipCodeIsAvailable()) {
      var zc = this.getQueryVariable("zip");
      const validStates = this.getValidStates();
      // console.log(`Enum`, this.options);
      validStates.forEach((validState) => {
        if (
          this.options.enums[8].enum.state[validState].some((o) => o.name === zc)
        ) {
          stateCode = validState;
        }
      });
    }
    return stateCode;
  }

  getValidStates() {
    // const options = await this.getCalculatorCriteriaOptions().then((optionsResponse)=>{
    return process.env.REACT_APP_VALID_ZIP.split(",");
    // return Object.keys(optionsResponse.enums[8].enum.state);
    // });
    // if(options){
    //   return process.env.REACT_APP_VALID_ZIP.split(',');
    // }
  }
  getLeadCloudApiURL() {
    let prodUrl = ['dev.segurosavanza.com', 'www.segurosavanza.com', 'stage.segurosavanza.com']
    // Fetch domain name via javascript
    console.log('this.hostName', this.hostName)
    console.log('prodUrl', prodUrl.find(v => (this.hostName === v)))
    if(prodUrl.find(v => (this.hostName === v))){
      console.log('Using prod')
      return `/calculator/server/leadcloud.php`;
    }else{
      console.log('getLeadCloudApiURL using localhost')
      return process.env.REACT_APP_SERVERHOST +`/calculator/server/leadcloud.php`;
    }
  }

  setDefaultBusinessZipCode() {
    var businessZc = "";
    // if (this.checkCustomZipCodeIsAvailable) {
    //   businessZc = this.getQueryVariable('zip');
    // }
    businessZc = this.getQueryVariable("zip");
    return businessZc;
  }

  // if language is not specified, set english as default
  setDefaultLanguage() {
    var lan = this.getQueryVariable("lan");
    if (lan !== "es") {
      lan = "en";
    }
    i18n.changeLanguage(lan).then(
      // console.log("change to " + lan)
    );
    return lan;
  }

  // changeLanguage = () => {
  //   var newLan;
  //   if (this.state.language === 'en') {
  //     newLan = "es";
  //   } else {
  //     newLan = "en";
  //   }
  //   i18n.changeLanguage(newLan).then(// console.log("change to "+newLan));
  //   this.setState({language: newLan})
  // }

  ifParamsMoveToStep2() {
    var zc = this.getQueryVariable("zip");
    var type = this.getQueryVariable("type");
    if (zc && type) {
      return 2;
    } else {
      return 1;
    }
  }

  // go back to previous step
  prevStep = () => {
    const { step } = this.state;
    this.setState({ step: step - 1 });
  };

  // proceed to the next step
  nextStep = () => {
    const { step } = this.state;
    this.setState({ step: step + 1 });
  };

  // handle field change
  handleChange = (input) => (e) => {
    let values = e.target.value;
    if (input === "businessPhone") {
      values = values.replace(/[^0-9-]/g, "");
      // console.log({ v: values });
      // console.log({
      //   state: this.state[input],
      //   length: this.state[input]["length"],
      // });
      if (values.length === 3 && values.length > this.state[input]["length"]) {
        values = values.slice(0, 3) + "-" + values.slice(3);
      }
      if (values.length === 7 && values.length > this.state[input]["length"]) {
        values = values.slice(0, 7) + "-" + values.slice(7);
      }
    } else if (input === "ageDriver") {
      values = values.replace(/[^0-9-]/g, "");
      if (values.length >= 2) {
        if (
          !Number(values) ||
          !(Number(values) >= 21 && Number(values) <= 75)
        ) {
          values = values.slice(0, values.length - 1);
        }
      }
    }
    this.setState({ [input]: values });
    // if (e.keyCode === 13) {
    //   // console.log('Enter');
    // }
    // // console.log(this.state);
  };
  // handle field change
  addToState = (name, value) => {
    this.setState({ [name]: value });
    // if (e.keyCode === 13) {
    //   // console.log('Enter');
    // }
    // // console.log(this.state);
  };

  // overnight zipcode same as business zipcode
  overnightSameAsBusiness = (value) => {
    var businessZipCode = this.state.businessMailingZipCode;
    this.setState({ overnightZipCode: businessZipCode });
    this.setState({ checkboxOvernightSameAsBusiness: value });
  };

  // handle the different values of the liability limits
  liabilityLimitsValues = (value) => {
    var pieces = value.split("/");
    this.setState({ bodilyInjury: pieces[0] + "k/" + pieces[1] + "k" });
    this.setState({ propertyDamage: pieces[2] + "k" });
  };

  // validating custom zip code is available
  handleCustomZipCode = () => {
    // console.log("handleCustomZip", this.checkCustomZipCodeIsAvailable());
    this.setState({ availableZipCode: this.checkCustomZipCodeIsAvailable() });
    if (this.checkCustomZipCodeIsAvailable()) {
      // setting stateCode
      var zc = this.state.zipCode;
      var stateCode = "";
      const validStates = this.getValidStates();
      validStates.forEach((validState) => {
        if (
          this.options.enums[8].enum.state[validState].some((o) => o.name === zc)
        ) {
          stateCode = validState;
        }
      });
      // console.log(stateCode);
      this.setState({ stateCode: stateCode });
      // setting default business zip code
      this.setState({ businessMailingZipCode: zc });
    }
  };

  // submit form data
  sendData = () => {
    var self = this; // see: https://stackoverflow.com/a/41196643/11748942

    let server_path = `/calculator/server/server.php`;
    if (process.env.NODE_ENV !== "production") {
      server_path = process.env.REACT_APP_SERVERHOST + server_path;
    }
    // const jsonData = generateJSONData(this.state);
    // // console.log({ jsonData: JSON.parse(jsonData) });
    axios
      .post(server_path, this.state) // PROD
      .then(function (res) {
        // console.log(res.data);
        self.setState({ result: res.data });
        self.setState({ resultMonthOptm: res.data.monthly.optimistic });
        self.setState({ resultMonthNormal: res.data.monthly.normal });
        self.setState({ resultMonthPesm: res.data.monthly.pesimistic });
        self.setState({ resultYearOptm: res.data.annual.optimistic });
        self.setState({ resultYearNormal: res.data.annual.normal });
        self.setState({ resultYearPesm: res.data.annual.pesimistic });
        const jsonData = generateJSONData(self.state, res.data);
        // console.log({ jsonData });
        self.sendJSONData(jsonData);
      })
      // const xml = generateXML(this.state)
      .catch(function (error) {
        // console.log(error);
      });
  };

  sendJSONData = (jsonData) => {
    //API URL by backend team
    axios
      .post(this.api_url, jsonData) // PROD
      .then(function (res) {
         console.log("Received data", res.data);
        // Action after API call
      })

      .catch(function (error) {
         console.log("error in sending data", error);
      });
  };

  render() {
    const { step } = this.state;
    const {
      formType,
      stateCode,
      zipCode,
      firstName,
      lastName,
      businessName,
      businessMailingZipCode,
      businessEmail,
      businessPhone,
      totalVehicles,
      industry,
      mainVehicle,
      estimatedValueVehicle,
      usage,
      overnightZipCode,
      checkboxOvernightSameAsBusiness,
      ageDriver,
      accidentsOrTickets,
      liabilityLimits,
      bodilyInjury,
      propertyDamage,
      availableZipCode,
      language,
    } = this.state;
    const values = {
      formType,
      stateCode,
      zipCode,
      firstName,
      lastName,
      businessName,
      businessMailingZipCode,
      businessEmail,
      businessPhone,
      totalVehicles,
      industry,
      mainVehicle,
      estimatedValueVehicle,
      usage,
      overnightZipCode,
      checkboxOvernightSameAsBusiness,
      ageDriver,
      accidentsOrTickets,
      liabilityLimits,
      bodilyInjury,
      propertyDamage,
      availableZipCode,
      language,
    };
    const {
      result,
      resultMonthOptm,
      resultMonthPesm,
      resultYearOptm,
      resultYearPesm,
    } = this.state;

    const { options } = this.state;
    const { validStates } = this.state;
    // console.log(values);

    switch (step) {
      case 1:
        return (
          <div>
            <Navigation />
            <Step1
              nextStep={this.nextStep}
              handleChange={this.handleChange}
              handleCustomZipCode={this.handleCustomZipCode}
              addToState={this.addToState}
              values={values}
            />
          </div>
        );
      case 2:
        return (
          <div>
            <Navigation />
            <Step2
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              handleChange={this.handleChange}
              values={values}
            />
          </div>
        );
      case 3:
        return (
          <div>
            <Navigation />
            <Step3
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              handleChange={this.handleChange}
              // changeLanguage={this.changeLanguage}
              options={options}
              validStates={validStates}
              values={values}
            />
          </div>
        );
      case 4:
        return (
          <div>
            <Navigation />
            <Step4
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              handleChange={this.handleChange}
              options={options}
              validStates={validStates}
              values={values}
            />
          </div>
        );
      case 5:
        return (
          <div>
            <Navigation />
            <Step5
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              sendData={this.sendData}
              handleChange={this.handleChange}
              handleOvernightCheckbox={this.overnightSameAsBusiness}
              handleLiabilityLimitsValues={this.liabilityLimitsValues}
              options={options}
              validStates={validStates}
              values={values}
              data={this.state}
            />
          </div>
        );
      case 6:
        return (
          <div>
            <Navigation />
            <Step6
              result={result}
              resultMonthOptm={resultMonthOptm}
              resultMonthPesm={resultMonthPesm}
              resultYearOptm={resultYearOptm}
              resultYearPesm={resultYearPesm}
              values={values}
              nextStep={this.nextStep}
            />
          </div>
        );
      default:
    }
  }
}
